export default {"src":"/_next/static/media/redacto-space.e5614d9d.svg","height":443,"width":605,"blurWidth":0,"blurHeight":0};